module.exports = "<div id=\"main-content\">\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.html
// module id = 550
// module chunks = 0